import { render } from "./WidgetMenu.vue?vue&type=template&id=152a98d8&scoped=true"
import script from "./WidgetMenu.vue?vue&type=script&lang=js"
export * from "./WidgetMenu.vue?vue&type=script&lang=js"

import "./WidgetMenu.vue?vue&type=style&index=0&id=152a98d8&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152a98d8"]])

export default __exports__